import React from 'react';

const DeliveryIconJag = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.28288 3.93165C9.25765 3.93219 9.23249 3.93457 9.2076 3.93877H4.60352V15.3971H16.0618V14.8763V3.93877H11.4618C11.4056 3.92947 11.3482 3.92947 11.292 3.93877H9.37138C9.34213 3.93388 9.31253 3.9315 9.28288 3.93165ZM5.64518 4.98043H8.77018V8.62627H11.8952V4.98043H15.0202V14.3554H5.64518V4.98043ZM9.81185 4.98043H10.8535V7.5846H9.81185V4.98043ZM11.8952 12.2721V13.3138H13.9785V12.2721H11.8952Z"
      fill="black"
    />
  </svg>
);

export default DeliveryIconJag;
